import { Vector3 } from 'three';
import { Dict } from '../../utils/Dict';

export type SectionPosition = {
    sectionPosition: Vector3,
    cameraOffset: Vector3,
    cameraLookAtOffset?: Vector3
};

export const SectionPositions: Dict<SectionPosition> = {
  VectorsOnly: {
    sectionPosition: new Vector3(0, 0.0, 0),
    cameraOffset: new Vector3(0, 0.8, 2),
    cameraLookAtOffset: new Vector3(0, 0.0, 0),
  },

  VectorsToSpheres: {
    sectionPosition: new Vector3(0, 0.0, 0),
    cameraOffset: new Vector3(0, 0.8, 2.5),
    cameraLookAtOffset: new Vector3(0, 0.0, 0),
  },

  SphereSubspaces: {
    sectionPosition: new Vector3(0, -3.0, 0),
    cameraOffset: new Vector3(0, 0.8, 2.5),
    cameraLookAtOffset: new Vector3(0, 0.0, 0),
  },

  TopologicalRelations: {
    sectionPosition: new Vector3(0, -6.0, 0),
    cameraOffset: new Vector3(0, 0.8, 2.5),
    cameraLookAtOffset: new Vector3(0, 0.0, 0),
  },

  DynamicBehavior: {
    sectionPosition: new Vector3(0, -9.0, 0),
    cameraOffset: new Vector3(0, 0.8, 2.5),
    cameraLookAtOffset: new Vector3(0, 0.0, 0),
  }
};
